/** @jsxRuntime classic */
/** @jsx jsx */
import { InterpolationWithTheme, jsx } from '@emotion/core';
import { List } from 'antd';
import { useStyles } from '~src/hooks/useStyles';
import { DbQuestionChangeLogItem } from '~src/types/db';
import { ReactNode } from 'react';
import { styleFn } from '../QuestionsList.styles';
import QuestionsChangeLogItem from './QuestionChangeLogItem';

export type QuestionsChangeLogProps = {
  questionLogs: DbQuestionChangeLogItem[] | undefined;
  isLoading: boolean;
  questionsListCss?: InterpolationWithTheme<any>;
  header?: ReactNode;
};

const QuestionsChangeLogList: React.FC<QuestionsChangeLogProps> = ({
  questionLogs,
  isLoading,
  questionsListCss,
  header,
}) => {
  const styles = useStyles(styleFn);

  return (
    <div
      css={[
        styles.container,
        { width: '100%', display: 'flex', justifyContent: 'center' },
      ]}>
      <List
        header={header}
        css={questionsListCss || styles.questionsList}
        dataSource={questionLogs}
        loading={isLoading}
        renderItem={(question) => (
          <QuestionsChangeLogItem question={question} />
        )}
      />
    </div>
  );
};

export default QuestionsChangeLogList;
